import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { VenueSurveyItem } from "src/app/shared/models/survey.model";

@Component({
	selector: "app-customer-survey-list",
	templateUrl: "./customer-survey-list.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSurveyListComponent implements OnInit {
	surveyList: VenueSurveyItem[];
	surveySubscription: Subscription;

	constructor(public app: AppService, public venueService: OOVenueService, public surveyService: SurveyService, private router: Router) {}

	ngOnInit(): void {
		this.surveySubscription = this.surveyService.surveyList.subscribe((survey) => {
			this.surveyList = [...survey];
		});
	}

	add() {
		const surveyId = (this.surveyService.surveyList.value.length + 1).toString();
		this.surveyService.surveyList.value.push(
			new VenueSurveyItem({
				pk: this.venueService.subscriptionVenue.value.key.toString(),
				sk: `SURVEY_${this.app.uuidv4()}`,
				surveyId: surveyId,
				surveyUrl: `http:/fpos.io/s/%k/${surveyId}/%c/%u?d=%d`,
			})
		);
		this.surveyService.surveyList.next(this.surveyService.surveyList.value);
		this.selectSurvey(this.surveyService.surveyList.value[this.surveyService.surveyList.value.length - 1].sk);
	}

	selectSurvey(surveyKey: string) {
		this.router.navigate([`cc/customers/survey/${surveyKey}`]);
	}
}
